import React from "react";
import "./style/Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
    <div className="footer-container">
      <div className="footer-logo">
        <h2>Oryyx</h2>
        <p>Your trusted industry partner.</p>
        {/* <br/> */}
        <p>
          We are dedicated for delivering <br/>
          innovative solutions that empower<br />
          businesses to achieve efficiency,<br/>
          sustainability, and growth.<br/>
          
        </p>
      </div>
  
      <div className="footer-links">
        <h3>Quick Links</h3>
        <ul>
          <li>
            <Link to={"/about"}>About</Link>
          </li>
          <li>
            <Link to={"/solution"}>Solutions</Link>
          </li>
          {/* <li>
            <Link to={"/partners"}>Partners</Link>
          </li> */}
          <li>
            <Link to={"/contact"}>Contact Us</Link>
          </li>
        </ul>
      </div>
  
      <div className="footer-contact1">
        <h3>Contact Us</h3>
        <p>
          Address:{""}
          <a> Building No.837, KAMAL COLONY,  Kamla Girls Hostel, Rohtak, Haryana, 124001
          
                  </a>
        </p>
       
        <p>
          Email:{" "}
          <a href="mailto:info@orryx.in" aria-label="Email">
            info@orryx.in
          </a>
        </p>
        <p>
          Phone:{" "}
          <a href="tel:91 xxxxxxx" aria-label="Phone">
            91 xxxxxxxx
          </a>
        </p>
      </div>
    </div>
    <div className="footer-bottom">
      <p>&copy; {new Date().getFullYear()} Oryyx. All rights reserved.</p>
    </div>
  </footer>
  
  );
};

export default Footer;
